import MainContent from '../../components/mainContent/MainContent';
import { PreLiquidacionContent } from './components/PreLiquidacionContent';

export default function PreLiquidacion() {
    return (
        <MainContent
            component={<PreLiquidacionContent />}
            titulo='Pre Liquidación'
            titleCondensed
        />
    );

};
